import styled from 'styled-components';
import { mediaQueryDesktopMin } from 'styleUtils';
var Wrapper = /*#__PURE__*/styled.aside.withConfig({
  componentId: "sc-12458zp-0"
})(["width:100%;@media ", "{width:300px;position:sticky;top:16px;}"], mediaQueryDesktopMin);
export default Wrapper;